const ServiceType = {
  SMS: 1,
  SERVER_SMTP: 2,
  EMAIL_SMTP: 3
}
export default ServiceType
